import styled from 'styled-components'
import { rem } from 'polished'

import { mediaQueryUp } from 'components/utils/breakpoint'

import { SEARCH_MENU_LIST_CAPTION_CLASS_NAME } from './SearchMenuListCaption'
import { SEARCH_MENU_LIST_ITEM_CLASS_NAME } from './SearchMenuListItem'

const SearchMenuList = styled.div`
  > .${SEARCH_MENU_LIST_CAPTION_CLASS_NAME} + .${SEARCH_MENU_LIST_ITEM_CLASS_NAME} {
    margin-top: ${rem(8)};

    ${mediaQueryUp.sm} {
      margin-top: ${rem(16)};
    }
  }
`

export default SearchMenuList
